import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { BrandHead } from './BrandHead';
interface SiteLayoutProps {
  children: React.ReactNode;
}
export function SiteLayout({
  children
}: SiteLayoutProps) {
  return <div className="flex min-h-screen w-full flex-col bg-warm" data-id="element-487" data-mp="34ttipgdmsnjv">
      <BrandHead data-id="element-488" data-mp="39ur74ap8idtt" />
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-navy focus:px-4 focus:py-3 focus:text-[14px] focus:font-semibold focus:text-white" data-id="element-489" data-mp="39v8zuxcou9wz">
        Skip to main content
      </a>
      <Header data-id="element-490" data-mp="3nlci7d8g5jh5" />
      <main id="main" className="flex-1" data-id="element-491" data-mp="3nmxbz0mxsydy">
        {children}
      </main>
      <Footer data-id="element-492" data-mp="3skpe0nhaq0vv" />
    </div>;
}